import React from 'react'
import PropTypes from 'prop-types'
import HTTPStatus from 'http-status'

export default class Error extends React.Component {
  static getInitialProps({ res, err }) {
    const statusCode = res?.statusCode || err?.statusCode
    return { statusCode }
  }

  getMessage(code) {
    switch (code) {
      case 404:
        return 'このページは存在しません。URLをご確認ください。'
      case 403:
        return 'このページは表示できません。'
      default:
        return '予期せぬエラーが発生しました。'
    }
  }

  getStatusDescription(code) {
    return HTTPStatus[code] || 'Unexpected Error'
  }

  render() {
    const { statusCode, errorMessage } = this.props
    const message = errorMessage || this.getMessage(statusCode)
    const statusDescription = this.getStatusDescription(statusCode)

    return (
      <div style={styles.error}>
        <div>
          {statusCode ? (
            <h1 style={styles.h1}>
              {statusCode}
              <span style={styles.statusDescription}>{statusDescription}</span>
            </h1>
          ) : null}
          <div style={styles.message}>
            <h2 style={styles.h2}>{message}</h2>
          </div>
        </div>
      </div>
    )
  }
}

if (process.env.NODE_ENV !== 'production') {
  Error.propTypes = {
    statusCode: PropTypes.number,
  }
}

const styles = {
  error: {
    color: '#fff',
    fontFamily: '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", "Fira Sans", Avenir, "Helvetica Neue", "Lucida Grande", sans-serif',
    textAlign: 'center',
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  h1: {
    display: 'inline-block',
    borderRight: '1px solid rgba(0, 0, 0,.3)',
    margin: 0,
    marginRight: '20px',
    padding: '10px 23px 10px 0',
    fontSize: '24px',
    fontWeight: 500,
    verticalAlign: 'middle',
    lineHeight: '1.2',
  },

  h2: {
    display: 'inline-block',
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: 1.4,
    margin: 0,
    padding: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },

  statusDescription: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '400',
    opacity: 0.7,
  },

  message: {
    display: 'inline-block',
    textAlign: 'left',
    lineHeight: '50px',
    height: '49px',
    verticalAlign: 'middle',
  },
}
